import { render, staticRenderFns } from "./ReminderControl.vue?vue&type=template&id=55df8075"
import script from "./ReminderControl.vue?vue&type=script&lang=js"
export * from "./ReminderControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports